<template src='./VehicleCategoryList.html'></template>
<script>
import { orderBy } from "@progress/kendo-data-query";
import CommandCell from "@/components/CommandCellTemplate/CommandCellTemplate";
import { createNamespacedHelpers } from "vuex";
const { mapState } = createNamespacedHelpers("vehicleCategory");
import { MESSAGES } from "@/utils/constants";
import { notify } from "@/utils/notification-helper";
// import vendorService from "@/api/vendorService";
// const apiMethods = require("./../../../../api/api")

export default {
  data: function() {
    return {
      // addoredit: false,
      gridData: [],
      skip: 0,
      take: 10,
      pageSize: 10,
      pageable: {
        pageSizes: true,
        previousNext: true
      },
      add: true,
      sort: [{ field: "code", dir: "asc" }],
      columns: [
        { field: "id", title: "ID" },
        { field: "categoryName", title: "Category" },

        { field: "vehicleType", title: "Name" },

        { field: "seat", title: "Seats" },

        { cell: CommandCell, title: "Actions", width: "200px" }
      ],
      dataItems: []
    };
  },
  methods: {
    sortChangeHandler: function(e) {
      this.sort = e.sort;
    },
    pageChangeHandler: function(event) {
      this.skip = event.page.skip;
      this.take = event.page.take;
    },
    showAdd: function() {
      this.add = true;
    },
    remove: function(item) {
      return this.$store
        .dispatch("vehicleCategory/removeCategory", item)
        .then(() => {
          notify(MESSAGES.CHANGES_SAVE_SUCCESS);
          this.getDataOnload();
        });
    },
    edit: function(item) {
      return this.$store.dispatch(
        "vehicleCategory/editCategoryr",
        item.dataItem
      ); //item.dataItem.id
    },
    async getDataOnload() {
      this.$store.dispatch("vehicleCategory/getVehicle");
    }
  },
  computed: {
    ...mapState({
      categoryList: state => state.CategoryList
    }),
    total() {
      return this.categoryList ? this.categoryList.length : 0;
    },
    items: {
      get: function() {
        return orderBy(
          this.categoryList.slice(this.skip, this.take + this.skip),
          this.sort
        );
      }
    }
  },
  created: function() {
    this.getDataOnload();
  }
};
</script>
